import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const NewsEntryLazy = loadable(() => import(/* webpackChunkName: "News" */ './NewsEntrySuspense'));

export const NewsEntryAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <NewsEntryLazy />
    </DelayedSuspense>
);
